<template>
	<strong class="font-medium text-zinc-950 dark:text-white">
		<slot />
	</strong>
</template>